import { IMAGES } from "./image";

// constants.js
export const PROJECTS = {
  safaricomMiniApp: {
    title: "Safaricom Mini App",
    description:
      "Built and integrated a mini application into the M-PESA Super App using Alipay mini-program architecture, enabling a compact, high-conversion mobile experience for customers and business services.",
    role: "Fullstack Developer",
    technologies: [
      "Mini App",
      "Next.js",
      "Express",
      "Flutter",
      "API Integration",
    ],
    modules: [
      {
        name: "Mini App Experience",
        description:
          "Delivered a compact mobile-first user journey integrated into the Safaricom ecosystem.",
        features: [
          "Super App integration",
          "Customer-facing workflows",
          "Responsive transaction UX",
        ],
      },
      {
        name: "Service Integration",
        description:
          "Connected with internal services and messaging flows for smooth user operations.",
        features: [
          "API orchestration",
          "Business logic integration",
          "Secure session handling",
        ],
      },
    ],
    galleryImages: [
      IMAGES.SafariMobile1Image,
      IMAGES.SafariMobile2Image,
      IMAGES.SafariMobile3Image,
    ],
  },
  safaricomPwa: {
    title: "Safaricom PWA Mobile Experience",
    description:
      "Developed a mobile-first PWA experience focused on lightweight access, offline-friendly interactions, and fast customer engagement across multiple digital journeys.",
    role: "Fullstack Developer",
    technologies: [
      "Progressive Web App",
      "Flutter",
      "Next.js",
      "API Integration",
    ],
    modules: [
      {
        name: "Mobile UX",
        description:
          "Built responsive customer journeys optimized for mobile performance and accessibility.",
        features: [
          "Offline-friendly UX",
          "Fast-loading interfaces",
          "Cross-device accessibility",
        ],
      },
    ],
    galleryImages: [
      IMAGES.SafariPwa1Image,
      IMAGES.SafariPwa2Image,
      IMAGES.SafariPwa3Image,
    ],
  },
  safaricomTelegramBot: {
    title: "Safaricom Telegram Bot",
    description:
      "Implemented an automated Telegram bot to drive customer engagement, answer routine requests, and reduce repetitive support work with structured workflows.",
    role: "Fullstack Developer",
    technologies: ["Telegram Bot", "Node.js", "Express", "Automation"],
    modules: [
      {
        name: "Automated Support",
        description:
          "Created customer automation flows for repetitive inquiries and service actions.",
        features: [
          "FAQ automation",
          "Workflow triggers",
          "Customer interaction routing",
        ],
      },
    ],
    galleryImages: [IMAGES.SafariBotImage],
  },
  safaricomEthqrPortal: {
    title: "ETHQR Portal",
    description:
      "Designed and developed the ETHQR portal to support QR-based transaction workflows with secure, traceable, and efficient service operations for business users.",
    role: "Fullstack Developer",
    technologies: ["React", "Next.js", "Node.js", "QR Systems"],
    modules: [
      {
        name: "QR Transaction Platform",
        description:
          "Built an operational portal for managing QR-driven transaction events and service flows.",
        features: [
          "QR workflow management",
          "User operations dashboard",
          "Business transaction tracking",
        ],
      },
    ],
    galleryImages: [IMAGES.SafariPortal1Image, IMAGES.SafariPortal2Image],
  },
  safaricomInternalPlatform: {
    title: "Safaricom Internal Business Platform",
    description:
      "Architected full-stack internal systems serving multiple business units, helping teams manage workflows, dashboards, and service operations through a unified platform.",
    role: "Fullstack Developer",
    technologies: ["Next.js", "Express", "Kubernetes", "GitLab", "CI/CD"],
    modules: [
      {
        name: "Business System Architecture",
        description:
          "Created internal applications to support operational and business unit needs with secure deployment patterns.",
        features: [
          "Multi-unit dashboards",
          "Service reporting",
          "Modern CI/CD delivery",
        ],
      },
    ],
    galleryImages: [IMAGES.SafariPortal1Image, IMAGES.SafariPortal2Image],
  },
  erpSystem: {
    title: "ABa ERP System",
    description:
      "A comprehensive ERP system designed to streamline business processes across multiple departments. Built using .NET, DevExpress, Crystal Reports, SQL, and hosted on IIS.",
    role: "Fullstack Developer",
    technologies: [".NET", "DevExpress", "Crystal Reports", "SQL", "IIS"],
    modules: [
      {
        name: "Human Resource Management (HR)",
        description:
          "Manages employee data, attendance, leaves, and performance reviews.",
        features: [
          "Employee Records Management",
          "Attendance & Leave Tracking",
          "Employee Self-Service (ESS) Portal",
          "Performance Appraisal System",
        ],
      },
      {
        name: "Payroll Management",
        description:
          "Handles salary calculations, tax deductions, and other compensation-related processes.",
        features: [
          "Salary Calculation & Payslip Generation",
          "Tax Deduction Management",
          "Bonus & Overtime Tracking",
          "Integration with Accounting Systems",
        ],
      },
      {
        name: "Finance & Accounting",
        description:
          "Manages financial transactions, reporting, and compliance.",
        features: [
          "General Ledger & Chart of Accounts",
          "Budgeting & Forecasting",
          "Accounts Payable & Receivable",
          "Tax Management & Compliance",
        ],
      },
      {
        name: "Inventory & Procurement",
        description:
          "Tracks stock levels, procurement, and supplier management.",
        features: [
          "Stock Tracking & Replenishment",
          "Supplier Management",
          "Purchase Order Management",
          "Inventory Valuation & Reporting",
        ],
      },
    ],
    galleryImages: [IMAGES.ERP],
  },
  lotteryApp: {
    title: "Aba Lottery Web App",
    description:
      "A lottery management web application enabling users to buy tickets, check results, and track winnings securely. Built with the MERN stack for a seamless experience.",
    role: "Fullstack Developer",
    technologies: ["React", "Node.js", "Express.js", "MongoDB"],
    modules: [
      {
        name: "Ticket Purchasing",
        description: "Allows users to purchase lottery tickets online.",
        features: [
          "Ticket Selection",
          "Payment Gateway Integration",
          "Ticket Confirmation Notifications",
        ],
      },
      {
        name: "Result Management",
        description:
          "Displays real-time lottery results and winnings to users.",
        features: [
          "Live Draw Result Updates",
          "Historical Lottery Data",
          "Personalized Result Notifications",
        ],
      },
      {
        name: "User Dashboard",
        description:
          "A personalized dashboard to track purchased tickets and winnings.",
        features: ["Ticket History", "Winning Summary", "Account Management"],
      },
      {
        name: "Admin Panel",
        description:
          "Provides admin users with tools to manage lottery operations.",
        features: [
          "Lottery Scheduling",
          "Result Publishing",
          "User Management",
        ],
      },
    ],
    galleryImages: ["lottery_ticket_selection.jpg"],
  },
  surveyCollectionApp: {
    title: "Survey Collection Web App",
    description:
      "A web-based application for collecting and managing survey data. Built with MERN stack, supporting real-time analytics and visualizations.",
    role: "Fullstack Developer",
    technologies: ["React", "Node.js", "Express.js", "MongoDB"],
    modules: [
      {
        name: "Survey Builder",
        description: "Allows admins to create and customize surveys.",
        features: [
          "Drag-and-Drop Survey Designer",
          "Question Bank Management",
          "Custom Branding for Surveys",
        ],
      },
      {
        name: "Survey Response Collection",
        description:
          "Handles secure and efficient collection of survey responses.",
        features: [
          "Multi-Language Support",
          "Offline Survey Submission",
          "Automated Email Notifications",
        ],
      },
      {
        name: "Reporting and Analytics",
        description:
          "Generates detailed reports and visualizations for survey data.",
        features: [
          "Real-Time Response Analytics",
          "Export to PDF and Excel",
          "Customizable Dashboards",
        ],
      },
    ],
    galleryImages: [IMAGES.SurveyDashboardImage, IMAGES.CreateSurveyImage],
  },
  zeneCommerce: {
    title: "ZeneCommerce — Ethiopia's Online Marketplace",
    description:
      "Built an online marketplace platform that connects buyers and sellers across Ethiopia with product discovery, seller management, and digital commerce workflows tailored for local market needs.",
    role: "Fullstack Developer",
    technologies: ["React", "Node.js", "Express", "MongoDB", "E-commerce"],
    modules: [
      {
        name: "Marketplace Experience",
        description:
          "Designed an accessible product discovery experience for digital commerce and local marketplace transactions.",
        features: [
          "Product browsing and discovery",
          "Seller storefront experience",
          "Responsive marketplace UX",
        ],
      },
      {
        name: "Commerce Operations",
        description:
          "Supported store and catalog workflows for a growing marketplace ecosystem.",
        features: [
          "Vendor management",
          "Product catalog workflows",
          "Order and listing management",
        ],
      },
    ],
    galleryImages: [IMAGES.Ecom1Image, IMAGES.Ecom2Image],
  },
  shareManagementApp: {
    title: "Share Management Mobile App",
    description:
      "A mobile app for managing shareholders, share transfers, and dividend payments. Built with Flutter and Dart.",
    role: "Frontend Developer",
    technologies: ["Flutter", "Dart", "Bloc", "AES Encryption"],
    modules: [
      {
        name: "Shareholder Management",
        description: "Handles shareholder information and records.",
        features: [
          "Shareholder Profiles",
          "Voting Rights Management",
          "Dividend History",
        ],
      },
      {
        name: "Share Transactions",
        description: "Facilitates the buying, selling, and transfer of shares.",
        features: [
          "Share Purchase Requests",
          "Transfer Approvals",
          "Transaction History",
        ],
      },
    ],
    galleryImages: [IMAGES.ShareLoginPageImage],
  },

  mobileBankingApp: {
    title: "ABa Mobile Banking App",
    description:
      "A secure mobile banking solution for managing accounts, transfers, and payments. Built using Flutter, Dart, and AES encryption. Developed For ABa( Amhara Bank)",
    role: "Frontend Developer",
    technologies: ["Flutter", "Dart", "Bloc", "AES Encryption"],
    modules: [
      {
        name: "Account Management",
        description: "Allows users to manage their bank accounts.",
        features: [
          "Account Balance Overview",
          "Transaction History",
          "Profile Management",
        ],
      },
      {
        name: "Fund Transfers",
        description:
          "Enables users to transfer funds securely between accounts.",
        features: [
          "Internal Transfers",
          "Interbank Transfers",
          "QR Code Transfers",
        ],
      },
      {
        name: "Bill Payments",
        description: "Simplifies utility and bill payments.",
        features: [
          "Electricity & Water Bill Payments",
          "Mobile Recharge",
          "Payment History",
        ],
      },
    ],
    galleryImages: [IMAGES.AccountScreenImage, IMAGES.MobileStartImage],
  },
  merchantApp: {
    title: "ABA Merchant Mobile App",
    description:
      "A mobile app for merchants to manage sales, payments, and customer interactions. Built with Flutter and Dart.",
    role: "Frontend Developer",
    technologies: ["Flutter", "Dart", "Bloc", "AES Encryption"],
    modules: [
      {
        name: "Sales Management",
        description: "Enables merchants to track and manage sales.",
        features: [
          "Sales Tracking",
          "Customer Receipts",
          "Daily Sales Reports",
        ],
      },
      {
        name: "Payment Processing",
        description: "Handles payment processing with multiple gateways.",
        features: [
          "Card Payment Integration",
          "Mobile Payment Support",
          "Transaction Notifications",
        ],
      },
    ],
    galleryImages: [IMAGES.MerchatProductImage, IMAGES.MerchantQRImage],
  },
  collegeManagenetWebApp: {
    title: "College Management System",
    description: "A comprehensive system to manage college operations.",
    role: "Fullstack Developer",
    technologies: [".NET", "DevExpress", "Crystal Reports", "SQL", "IIS"],
    modules: [
      {
        name: "Registrar Management",
        description: "Handles student enrollment and academic records.",
        features: [
          "Online Application Submission",
          "Document Verification",
          "Transcript Generation",
          "Course Registration Management",
        ],
      },
      {
        name: "Human Resources Management",
        description: "Manages faculty and staff recruitment and records.",
        features: [
          "Job Postings and Application Tracking",
          "Interview Scheduling",
          "Performance Appraisal Management",
          "Payroll Processing",
        ],
      },
      {
        name: "Finance Management",
        description:
          "Oversees financial operations including budgeting and billing.",
        features: [
          "Budget Proposal Submissions",
          "Expense Tracking",
          "Invoice Generation",
          "Financial Aid Processing",
        ],
      },
      {
        name: "College Departments Management",
        description:
          "Supports various academic departments in managing operations.",
        features: [
          "Course Creation and Scheduling",
          "Enrollment Tracking",
          "Departmental Reporting",
          "Faculty Workload Assessments",
        ],
      },
    ],
    galleryImages: [IMAGES.collegeAddStaff, IMAGES.CollegeFinancialReport],
  },
  mobileBankingWebPortal: {
    title: "ABa Mobile Apps Web Portal",
    description:
      "A web-based administrative portal designed to manage user accounts, monitor transactions, and generate reports for the Aba mobile applications. Built with the MERN stack for scalability and reliability.",
    role: "Fullstack Developer",
    technologies: ["React", "Node.js", "Express.js", "MongoDB"],
    modules: [
      {
        name: "User Management",
        description: "Administer and monitor user accounts.",
        features: [
          "User Registration & Verification",
          "Role-Based Access Control",
          "Account Status Monitoring",
        ],
      },
      {
        name: "Transaction Monitoring",
        description: "Track and analyze user transactions.",
        features: [
          "Real-Time Transaction Logs",
          "Suspicious Activity Alerts",
          "Detailed Transaction History",
        ],
      },
      {
        name: "Reports & Analytics",
        description:
          "Generate detailed insights and analytics for financial performance.",
        features: [
          "Daily/Monthly Financial Reports",
          "Customizable Data Dashboards",
          "Export to CSV/PDF",
        ],
      },
    ],
    galleryImages: [
      "banking_portal_user_management.jpg",
      "banking_portal_transactions.jpg",
      "banking_portal_reports.jpg",
    ],
  },
  uiUxDesign: {
    title: "UI/UX Design for  Applications",
    description:
      "Designed user-friendly and visually appealing interfaces for mobile and web applications, focusing on enhancing user experience and aligning designs with project objectives. Used Figma and Canva to create intuitive layouts, prototypes, and design assets.",
    role: "UI/UX Designer",
    technologies: ["Figma", "Canva", "Adobe XD"],
    modules: [
      {
        name: "Mobile Banking App",
        description:
          "Created a seamless design for the mobile banking app, ensuring ease of navigation, secure interactions, and a professional look.",
        features: [
          "Account Management UI",
          "Fund Transfer Workflow",
          "Bill Payment Flow",
        ],
      },
      {
        name: "Merchant Web Portal",
        description:
          "Developed a responsive web portal for merchants to manage inventory, sales, and analytics efficiently.",
        features: [
          "Inventory Management Dashboard",
          "Sales Analytics Interface",
          "Customer Interaction Tools",
        ],
      },
      {
        name: "Lottery Web App",
        description:
          "Crafted a modern design for the lottery app, focusing on ticket purchase ease, result tracking, and user engagement.",
        features: [
          "Interactive Ticket Selection",
          "Real-Time Result Display",
          "User Dashboard Design",
        ],
      },
    ],
    galleryImages: [IMAGES.UIDesignImage],
  },
  appreciationCertificate: {
    title: "Appreciation Certificate",
    description:
      "Awarded for exceptional contributions and performance across various projects and domains.",
    role: "Recipient",
    technologies: [],
    modules: [
      {
        name: "Professional Achievement",
        description:
          "Recognized for outstanding commitment to project delivery and quality assurance.",
        features: [
          "Acknowledged leadership in team collaboration.",
          "Delivered critical project modules under tight deadlines.",
          "Promoted a culture of innovation and excellence.",
        ],
      },
      {
        name: "Teamwork and Leadership",
        description: "Recognized for significant impact as a team leader.",
        features: [
          "Successfully guided teams through complex challenges.",
          "Mentored junior developers, ensuring their growth.",
          "Maintained high morale through collaborative problem-solving.",
        ],
      },
    ],
    galleryImages: [IMAGES.AppreciateImage],
  },
  courseCompletionCertificate: {
    title: "Course Completion Certificate",
    description:
      "Earned upon successful completion of specialized professional training programs.",
    role: "Learner",
    technologies: [],
    modules: [
      {
        name: "Flutter and Dart Mastery",
        description: "Completed advanced training in mobile development.",
        features: [
          "Built scalable mobile applications using Flutter.",
          "Learned advanced state management with Bloc.",
          "Mastered AES encryption for secure data handling.",
        ],
      },
      {
        name: "Fullstack MERN Development",
        description: "Mastered web development using the MERN stack.",
        features: [
          "Developed dynamic, interactive frontends using React.",
          "Implemented secure RESTful APIs with Node.js and Express.",
          "Designed scalable NoSQL databases using MongoDB.",
        ],
      },
      {
        name: ".NET Framework and DevExpress",
        description: "Specialized in enterprise-grade app development.",
        features: [
          "Built ERP modules using DevExpress components.",
          "Automated reporting systems using Crystal Reports.",
          "Configured and optimized IIS for application deployment.",
        ],
      },
    ],
    galleryImages: [IMAGES.FigmaCertificate, IMAGES.NodeCertificate],
  },
  recommendationCertificate: {
    title: "Recommendation Certificate",
    description:
      "Endorsed for technical expertise and professional achievements by leaders and organizations.",
    role: "Endorsed Professional",
    technologies: [],
    modules: [
      {
        name: "Technical Excellence",
        description: "Endorsed for expertise in web and mobile development.",
        features: [
          "Acknowledged for advanced skills in Flutter and Dart.",
          "Demonstrated excellence in .NET-based ERP solutions.",
          "Recommended for innovative problem-solving approaches.",
        ],
      },
      {
        name: "Client Satisfaction",
        description: "Earned recognition for outstanding client delivery.",
        features: [
          "Built user-centric designs that exceeded expectations.",
          "Ensured smooth handoffs and technical documentation.",
          "Delivered results on or ahead of schedule.",
        ],
      },
    ],
    galleryImages: ["recommendation_letter.jpg", "client_feedback.jpg"],
  },
};
